"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "APPROVAL_PROCESS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.APPROVAL_PROCESS;
  }
});
Object.defineProperty(exports, "ASSET_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ASSET_MANAGEMENT;
  }
});
Object.defineProperty(exports, "BRANDING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BRANDING;
  }
});
Object.defineProperty(exports, "CONTENT_AUTHORING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CONTENT_AUTHORING;
  }
});
Object.defineProperty(exports, "CONTENT_QUEUE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CONTENT_QUEUE;
  }
});
Object.defineProperty(exports, "CONTENT_REPOSITORY", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CONTENT_REPOSITORY;
  }
});
Object.defineProperty(exports, "CUSTOMIZABLE_TEMPLATES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CUSTOMIZABLE_TEMPLATES;
  }
});
Object.defineProperty(exports, "CUSTOMIZATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CUSTOMIZATION;
  }
});
Object.defineProperty(exports, "MOBILE_SUPPORT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MOBILE_SUPPORT;
  }
});
Object.defineProperty(exports, "OPEN_API", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.OPEN_API;
  }
});
Object.defineProperty(exports, "PAGE_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PAGE_MANAGEMENT;
  }
});
Object.defineProperty(exports, "PLUGINS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PLUGINS;
  }
});
Object.defineProperty(exports, "SEO_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SEO_MANAGEMENT;
  }
});
Object.defineProperty(exports, "USER_PERMISSIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.USER_PERMISSIONS;
  }
});
Object.defineProperty(exports, "VERSION_CONTROL", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.VERSION_CONTROL;
  }
});
Object.defineProperty(exports, "W3C_COMPLIANCE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.W3C_COMPLIANCE;
  }
});
Object.defineProperty(exports, "WEB_TRAFFIC_ANALYTICS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.WEB_TRAFFIC_ANALYTICS;
  }
});
Object.defineProperty(exports, "WORD_PROCESSOR", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.WORD_PROCESSOR;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/CMS.js
// module id = 564
// module chunks = 209 210 211 212 213